import { createFileRoute, Navigate } from '@tanstack/react-router'

function AdminIndex() {
  return <Navigate to="/admin/tenants" replace />
}

export const Route = createFileRoute('/admin/')({
  component: AdminIndex,
})
